import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { LEARNING_HUB_MODULE_PATH } from '../../definitions/learning-hub.constants';
import { LearningHubArticleMeta } from '../../definitions/learning-hub.models';

/** List of articles as rows (title + arrow, optional summary), like the category pages of the old site. */
@Component({
  selector: 'app-learning-hub-article-rows',
  templateUrl: './article-rows.component.html',
  styleUrls: ['./article-rows.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ArticleRowsComponent {
  @Input() articles: LearningHubArticleMeta[] = [];
  @Input() showSummary = false;

  readonly modulePath = LEARNING_HUB_MODULE_PATH;

  trackById(_index: number, article: LearningHubArticleMeta): number {
    return article.id;
  }
}
